import { render } from "./ContactMailComponent.vue?vue&type=template&id=baf398f4"
import script from "./ContactMailComponent.vue?vue&type=script&lang=js"
export * from "./ContactMailComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__